import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import StockoutproductEditForm from './StockoutproductEditForm';
import StockoutproductList from './StockoutproductList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import StockoutproductListView from './StockoutproductListView'


export default function StockoutproductDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.manufslice.stockoutproductDashboard);
  const [ stockoutproductId, setStockoutproductId] = React.useState('');
  const [reloadStockoutproductList, setReloadStockoutproductList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <StockoutproductEditForm 
            setReloadStockoutproductList={setReloadStockoutproductList}
            stockoutproductId={stockoutproductId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <StockoutproductListView 
                      setStockoutproductId = {setStockoutproductId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
